<template>
  <!-- Implementa il form per l'immissione di una nuova password ( campo "nuova password"  -->
  <!-- e "conferma nuova password" )il quale ne controlla durante l'immissione la validità -->
  <!-- semantica stessa e la correttezza della digitazione.                                -->
  <!-- Viene realizzato con i soli elementi form-group per poterlo impiegare all'interno   -->
  <!-- form dove possono essere presenti altri dati (es email utente o la vecchia password -->
  <!-- da cambiare ) a seconda delle casistiche di cambio password che si presentano.      -->
  <div>
    <!-- Nuova password -->
    <b-form-group
      id="new-passwd-group"
      :label="new_passwd_label"
      label-for="new-passwd"
      :invalidFeedback="new_passwd_help_text"
    >
      <b-input-group>
        <b-input-group-prepend class="pr-2">
          <b-icon icon="check2" font-scale="2"></b-icon>
        </b-input-group-prepend>
        <b-form-input
          id="new-passwd"
          v-model="form.new_passwd"
          :state="form_state.new_passwd"
          type="password"
          required
          :placeholder="new_passwd_placeholder"
        ></b-form-input>
      </b-input-group>
    </b-form-group>

    <!-- Conferma nuova password -->
    <b-form-group
      id="passwd-confirm-group"
      :label="passwd_confirm_label"
      label-for="passwd-confirm"
      :invalidFeedback="passwd_confirm_help_text"
    >
      <b-input-group>
        <b-input-group-prepend class="pr-2">
          <b-icon icon="check2" font-scale="2"></b-icon>
        </b-input-group-prepend>
        <b-form-input
          id="passwd-confirm"
          v-model="form.passwd_confirm"
          :state="form_state.passwd_confirm"
          type="password"
          required
          :placeholder="passwd_confirm_placeholder"
        ></b-form-input>
      </b-input-group>
    </b-form-group>
  </div>
</template>



<script>
export default {
  name: 'FormNuovaPassword',
  data () {
    return {

      // Dati del form
      form : {
        new_passwd : null,
        passwd_confirm : null
      },

      // Stato ok/ko degli elementi del form
      form_state : {
        new_passwd : null,
        passwd_confirm : null
      },

      // Flag per capire se il ko del check password è dovuto
      // alla lunghezza o alla semantica ( utile nelle computed
      // per l'help text )
      passw_len_ok : true,
      passw_content_ok : true
    }
  },
  methods : {
    /**
     * Emette i dati interni del form al parent tramite l'evento dataChanged.
     * Torniamo sia i dati del form che gli state dei due campi ( null o false )
     * perchè potrebbero essere utili per fare delle valutazioni nel parent.
     */
    emit_data_to_parent : function () {
        let data = { new_passwd : this.form.new_passwd,
                     passwd_confirm : this.form.passwd_confirm,
                     new_passwd_state : this.form_state.new_passwd,
                     passwd_confirm_state : this.form_state.passwd_confirm };
        this.$emit( 'dataChanged', data );
    }
  },
  computed : {
    /**
     * Helptext della nuova password se lo stato non è corretto
     */
    new_passwd_help_text : function () {
      if ( this.form_state.new_passwd === false ) {
        let message = '';
        if ( !this.passw_len_ok ) {
          message += " La nuova password deve avere tra 8 e 32 caratteri, hai digitato " + this.form.new_passwd.length + " caratteri.";
        }
        if ( !this.passw_content_ok ) {
          message += " La password deve contenere almeno un carattere maiuscolo uno minuscolo ed un numero."
        }
        return message;
      } else {
        return "";
      }
    },
    /**
     * Helptext della conferma password se lo stato non è corretto
     */
    passwd_confirm_help_text : function () {
      if ( this.form_state.passwd_confirm === false ) {
        return "Le due password non coincidono"
      } else {
        return "";
      }
    }
  },
  watch : {
    /**
     * Prima controllo i valori singoli della nuova password e della conferma
     * per capire se lo state va resettato ( cioè se ho cancellato quello che ho
     * scritto ) poi controllo l'intero oggetto form per vedere le variazioni del
     * campo nuova password rispetto al conferma password.
     */
    'form.new_passwd' : function ( val ) {
        if ( val === null || val === '' ){
          this.form_state.new_passwd = null;
        }
    },
    'form.passwd_confirm' : function ( val ) {
        if ( val === null || val === '' ){
          this.form_state.passwd_confirm = null;
        }
    },
    /**
     * Controllo dell'oggetto form
     */
    form: {
      handler( val ){

        // Notifico i nuovi dati al parent poi eseguo le verifiche
        this.emit_data_to_parent();

        // Verifica campo nuova password, procedo solo se il campo non è nullo
        // verifico songolarmente la lunghezza e la forma della password e poi
        // decido lo stato della casella di input.
        if ( val.new_passwd === '' || val.new_passwd === null ) {
          return;
        } else {
          // Controlliamo poi che la password stia tra 8 e 32 caratteri
          if ( val.new_passwd.length > 0 && ( val.new_passwd.length < 8 || val.new_passwd.length > 32 ) ) {
            this.passw_len_ok = false;
          } else {
            this.passw_len_ok = true;
          }

          // Controlliamo che abbia almeno un carattere minuscolo uno maiuscolo ed un numero
          const lower_case = new RegExp('[a-z]+','g');
          const upper_case = new RegExp('[A-Z]+','g');
          const number = new RegExp('[0-9]+','g');
          if ( lower_case.test(val.new_passwd) === true && upper_case.test(val.new_passwd) === true & number.test(val.new_passwd) === true ){
            this.passw_content_ok = true;
          } else {
            this.passw_content_ok = false;
          }

          if ( this.passw_content_ok == false || this.passw_len_ok == false ) {
            this.form_state.new_passwd = false;
          }else{
            this.form_state.new_passwd = null;
          }
        }

        // Verifica campo conferma password, procedo solo se il campo non è nullo
        if ( val.passwd_confirm === '' || val.passwd_confirm === null ) {
          return;
        } else {
          // verifico l'uguaglianza tra i due campi
          if ( val.new_passwd === val.passwd_confirm ) {
            this.form_state.passwd_confirm = null;
          } else {
            this.form_state.passwd_confirm = false;
          }
        }

      },
      deep : true
    },
    /**
     * Controllo anche l'oggeto che da lo state dei due campi del form per notificarne la variazione
     * al parent
     */
    form_state: {
      handler( val ){
        this.emit_data_to_parent();
      },
      deep: true
    }
  },
  props : {
    /**
     * Etichetta input box immissione nuova password
     */
    new_passwd_label: {
      type: String,
      default: "Scrivi qui la nuova password:"
    },
    /**
     * Etichetta input box immissione conferma password
     */
    passwd_confirm_label: {
      type: String,
      default: "Digita nuovamente la nuova password:"
    },
    /**
     * Placeholder input box immissione nuova password
     */
    new_passwd_placeholder: {
      type: String,
      default: "Nuova password"
    },
    /**
     * Placeholder input box immissione conferma password
     */
    passwd_confirm_placeholder: {
      type: String,
      default: "Conferma nuova password"
    }
  }
}
</script>

<style scoped></style>